<template>
	<v-container>
		<div v-if="isMobile && person && lodging">
			<checker :disabled="fetchLoading" :disabledBtn="disabledBtn" />
		</div>
		<v-row v-if="guestPersonregister" justify="center" align="center" style="height:85vh">
			<v-col cols="12">
				<guest-person-register
					:personId="idPerson"
					:person="person"
					:token="token"
					finaltext="Respuesta validada, Redigiriendo a su cuenta..."
				/>
			</v-col>
		</v-row>
		<v-row v-else justify="center" align="center" :style="!isMobile && 'height: 100%'">
			<v-col cols="12" md="6">
				<v-card outlined :loading="fetchLoading" min-height="120">
					<v-card-text v-if="fetchLoading" class="caption">Cargando...</v-card-text>
					<template v-else>
						<template v-if="person && lodging">
							<v-card-text class="subtitle-1 text--secondary text-center">
								{{ text }}
							</v-card-text>
							<v-card-actions>
								<v-spacer></v-spacer>
								<v-btn color="primary" @click="changeState(1)" :disabled="disabled">
									Si
								</v-btn>
								<v-btn color="primary" @click="changeState(2)" :disabled="disabled">
									No
								</v-btn>
								<v-spacer></v-spacer>
							</v-card-actions>
						</template>
						<template v-if="!fetchLoading && !person && !lodging">
							<v-card-text class="title text--secondary text-center">
								Su enlace ha exiparado
							</v-card-text>
						</template>
					</template>
				</v-card>
			</v-col>
		</v-row>
		<v-row>
			<v-col v-if="lodging && lodging.notes.length">
				<b>Notas para esta actividad:</b>
				<v-col cols="12" v-for="(note, idNotes) in lodging.notes" :key="idNotes + 'note'">
					<span>{{ formatDate(note.createdAt) }}:<br />{{ note.text }}</span>
					<br />
				</v-col>
				<span class="caption"
					>Recuerda siempre tener al dia tus OT, selecionando en tu actividad y luego
					documentos: <br />Agregar OT</span
				>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import { mapMutations } from 'vuex';
import { api as baseURL } from '@/config/index.js';
import evaluateErrorReturn from '@/utils/errors/evaluateErrorReturn';

export default {
	components: {
		Checker: () => import('@/components/persons/Checker'),
		GuestPersonRegister: () => import('@/components/auth/GuestPersonRegister'),
	},
	data() {
		return {
			guestPersonregister: false,
			fetchLoading: false,
			token: '',
			idPerson: '',
			idLodging: '',
			idNotification: '',
			person: null,
			lodging: null,
			disabled: false,
		};
	},
	computed: {
		text() {
			if (this.person && this.lodging)
				return `Hola ${this.person.firstName} ¿Estás trabajando en ${
					this.lodging.place.name
				} desde día ${moment(this.lodging.start).format('DD-MM-YYYY')}?`;
			return '';
		},
	},
	created() {
		let data = this.$route.params.token;
		let buff = new Buffer(data, 'base64');
		this.token = buff.toString('ascii');
		this.idPerson = this.$route.params.id;
		this.idLodging = this.$route.params.lodging;
		this.idNotification = this.$route.params.idNotification;
	},
	mounted() {
		this.initialFetch();
	},
	methods: {
		formatDate(date) {
			return moment(date).format('DD-MM-YYYY HH:mm');
		},
		async initialFetch() {
			try {
				this.fetchLoading = true;
				await this.getPerson();
				await this.getLodging();
			} catch (error) {
				this.snackbar({
					content: this.errorMessage(error),
					color: 'error',
				});
			} finally {
				this.fetchLoading = false;
			}
		},
		async getPerson() {
			const { data } = await axios.get(`${baseURL}/person/${this.idPerson}`, {
				headers: {
					Authorization: `Bearer ${this.token}`,
				},
			});
			this.setPerson(data.person);
			this.person = data.person;
		},
		async getLodging() {
			const { data } = await axios.get(`${baseURL}/timeline/person/${this.idPerson}`, {
				headers: {
					Authorization: `Bearer ${this.token}`,
				},
			});
			this.setLodgingsOfPerson(data.lodgings);
			this.lodging = data.lodgings.find(lod => lod._id === this.idLodging);
		},
		async changeState(newState) {
			try {
				this.fetchLoading = true;
				await axios(
					`${baseURL}/lodging/${this.idLodging}/notification/${this.idNotification}`,
					{
						method: 'put',
						data: { state: newState },
						headers: {
							Authorization: `Bearer ${this.token}`,
						},
					}
				);
				this.snackbar({
					content: 'Respuesta enviada.',
					color: 'success',
				});
				this.guestPersonregister = true;
			} catch (e) {
				this.snackbar({
					content: evaluateErrorReturn(this.errorMessage(e)),
					color: 'error',
				});
			} finally {
				this.fetchLoading = false;
			}
		},
		disabledBtn() {
			this.disabled = !this.disabled;
		},
		errorMessage(e) {
			const status = e.response.status === 401;
			return status ? 'Ha expirado este enlace' : e;
		},
		...mapMutations({
			snackbar: 'Snackbar/showMessage',
			setPerson: 'Person/setPerson',
			setLodgingsOfPerson: 'Lodging/setLodgingsOfPerson',
		}),
	},
};
</script>
